<template>
  <v-container class="initialInfoContainer">
      <template style="background-color:white;">
          <!-- <v-card> -->
              <v-container fluid style="background-color:white;">
                  <v-layout row wrap px-4 py-4 dir="auto" style="background-color:white;">
                      <v-flex class="preLoginHeaderstyle" id="createAccount">
                         <b><label style="font-family: Arial;">CREATE ACCOUNT</label></b>
                      </v-flex>
                     <!-- First Name -->
                     <v-flex xs12 sm12 md12 mt-2 style="margin-bottom:2px !important;" >
                          <div class="small-input">
                              <label class="grey--text text--darken-2">
                                  <b dir="auto" style="margin-bottom: 7px; font-family: Arial;">First Name</b><sub style="color:red;font-size:larger"> *</sub>
                              </label>
                              <!-- <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign alphabetSpace" transition="slide-x-transition" id=""  maxlength="30"  label="First Name" solo v-model="firstName"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^a-zA-Z ]/gi, '');" v-on:focusout="RemoveSpace($event)" v-on:keypress="isAlphabetSpace($event)">
                              </v-text-field> -->

                              <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign alphabetSpace" transition="slide-x-transition" id=""  maxlength="30"  label="First Name" solo v-model="firstName"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^a-zA-Z ]/gi, '');" v-on:focusout="RemoveSpace($event,'firstName',firstName)" @keypress="isAlphabetSpace($event)">
                              </v-text-field>
                             
                              <div style="color:red;  font-size: 12px;" v-if="firstNameErrorMsg.length > 0">{{firstNameErrorMsg}}</div>
                          </div>
                      </v-flex>
                     <v-flex xs12 sm12 md12 mt-2 style="margin-bottom:2px !important;">
                          <div class="small-input">
                              <label class="grey--text text--darken-2">
                                  <b dir="auto" style="margin-bottom: 7px; font-family: Arial;">Last Name</b><sub style="color:red;font-size:larger"> *</sub>
                              </label>
                                  <!-- <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign alphabetSpace" transition="slide-x-transition" id=""  maxlength="30"  label="Last Name" solo v-model="lastName"   oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^a-zA-Z ]/gi, '');" v-on:focusout="RemoveSpace($event)" v-on:keypress="isAlphabetSpace($event)">
                              </v-text-field> -->
                              <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign alphabetSpace" 
                            transition="slide-x-transition" id=""  maxlength="30"  label="Last Name" solo 
                            v-model="lastName"   
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^a-zA-Z ]/gi, '');" 
                            v-on:focusout="RemoveSpace($event, 'lastName', lastName)" @keypress="isAlphabetSpace($event)">
                            </v-text-field>
                              <div style="color:red;  font-size: 12px;" v-if="lastNameErrorMsg.length > 0">{{lastNameErrorMsg}}</div>
                          </div>
                      </v-flex>


                  <!-- Cust ID -->
                      <v-flex xs12 sm12 md12 mt-2 style="margin-bottom:2px !important;">
                          <div class="small-input">
                              <label class="grey--text text--darken-2">
                                  <b dir="auto" style="margin-bottom: 7px; font-family: Arial;">Customer ID</b><sub style="color:red;font-size:larger"> *</sub>
                              </label>
                                  <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign alphabetSpace" transition="slide-x-transition" id="" type="tel" inputmode="numeric" maxlength="9"  placeholder="Customer ID" solo v-model="custID" v-on:keypress="isNumber($event)"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');">
                              </v-text-field>
                              <div style="color:red;  font-size: 12px;" v-if="custIDErrorMsg.length > 0">{{custIDErrorMsg}}</div>
                          </div>
                      </v-flex>

                      <v-flex xs12 sm12 md12 mt-2 style="margin-bottom: 2px !important">
                          <div class="small-input">
                              <label class="grey--text text--darken-2">
                                  <b dir="auto" style="margin-bottom: 7px; font-family: Arial">Email ID </b><sub style="color:red;font-size:larger"> *</sub>
                              </label>
                              <v-text-field full-width class="mt-2 mb-0" transition="slide-x-transition" id="" placeholder="Email ID" maxLength="30" solo v-model="email" v-on:keypress="emailRestrict($event)" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/[^a-zA-Z0-9.@_]/gi, '');">
                              </v-text-field>
                              <div style="color:red;font-size: 12px;" v-if="emailerrormsg.length > 0" >{{emailerrormsg}}</div>
                          </div>
                      </v-flex>

                      <!-- <v-flex xs12 sm12 md12 mt-2 style="margin-bottom: 2px !important" >
                          <div class="small-input">
                              <label class="grey--text text--darken-2">
                                  <b dir="auto" style="margin-bottom: 7px; font-family:Arial;"> Mobile Number</b><sub style="color:red;font-size:larger"> *</sub>
                              </label>
                              <div>
                              <vue-multiselect  v-model="ISD" :options="DrpDwnopt" label="OptionText" :searchable="true" :show-labels="false" :close-on-select="true" class="ISDStyle" placeholder="ISD"></vue-multiselect>

                              <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign"  transition="slide-x-transition" id="" type="tel" inputmode="numeric"  placeholder="Enter Mobile Number" maxLength="11" solo  v-on:keypress="isNumber($event)" v-model="mobNo"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');">
                              </v-text-field>
                          </div>
                              <div style="color:red;  font-size: 12px;" v-if="mobNoErrorMsg.length > 0">{{mobNoErrorMsg}}</div>
                          </div>
                      </v-flex>  -->

                      <v-flex xs12 sm12 md12 mt-2 style="margin-bottom: 2px !important" >
                          <div class="small-input">
                              <label class="grey--text text--darken-2">
                                  <b dir="auto" style="margin-bottom: 7px; font-family:Arial;"> Mobile Number</b><sub style="color:red;font-size:larger"> *</sub>
                              </label>
                              <div>
                              <vue-multiselect  v-model="ISD" :options="DrpDwnopt" label="OptionText" :searchable="true" :show-labels="false" :close-on-select="true" class="ISDStyle" placeholder="ISD"></vue-multiselect>

                              <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign"  transition="slide-x-transition" id="" type="tel" inputmode="numeric"  placeholder="Enter Mobile Number" maxLength="11" solo  v-on:keypress="isNumber($event)" v-model="mobNo"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');">
                              </v-text-field>
                          </div>
                              <div style="color:red;  font-size: 12px;" v-if="mobNoErrorMsg.length > 0">{{mobNoErrorMsg}}</div>
                          </div>
                      </v-flex>


                      <!-- <v-flex xs12 sm12 md12 v-if="Isnextclicked === 'True'">
                          <v-layout row justify-center>
                              <v-flex xs12 sm12 md6 >
                                  <h2 style="text-align:center;">Please Wait</h2>
                              </v-flex>
                          </v-layout>
                      </v-flex> -->
                      <v-flex xs12 sm12 md12 v-if="Isnextclicked === 'False'">
                          <v-layout row justify-center>
                              <div>
                                  <v-btn color="primary-btn" id="nextBtn" dark block class="text-none" @click="continue_button_click()" >Next</v-btn>
                              </div>
                          </v-layout>
                      </v-flex>
                  </v-layout>
              </v-container>
          <!-- </v-card> -->
      </template>
      <!--Preloader starts-->
          <!-- <div class="pre-loader" v-show="PreLoader==true">
              <v-container fluid="" justify-center="true" fill-height="true">
                      <img src="@/assets/images/Preloader.gif">
              </v-container>

          </div> -->
      <!--Preloader ends-->

<!-- MODAL STARTS -->
<v-card class="modal-backdrop" ref="modal" id="loginModal" data-keyboard="false" data-backdrop="static" v-show="isModalVisible">
  <div class="modal" style="width: 26rem;">
    <section class="modal-body">
      <slot name="body">
          <v-flex style="text-align: center;font-size: 20px;">
                         <b><label style="font-family: Calibri (Body);"  > OTP Verification</label></b>
          </v-flex>
          <br/>
     
  <div style="padding-bottom: 8px;">
      <v-flex style="padding-left:2rem; padding-right: 2rem; text-align: center;">
      <label class="grey--text text--darken-2">
          <p  style="font-family: Calibri (Body);font-size: 11px;">  <b>Enter OTP sent to registered Mobile/Email ID.</b></p>
      </label>
      <h5 style="font-family: Calibri (Body);color: darkgrey; font-size: 11px;" id="otpMsgE" >{{otpMessageE}}</h5>
  <div class ="container">
      <div class="row">

          <div class="float-child" style="border-radius: 8px !important;">
       <!-- <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="11" :autocomplete="'off'"  maxLength="1" solo v-model="emailOtp11" @input="moveToNextField($event, 11)" oncopy="return false" onpaste="return false"  oninput="javascript:   this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
       </v-text-field> -->
       <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="11" :autocomplete="'off'"  maxLength="1" solo v-model="$sunidhi.emailOtp11" @input="moveToNextField($event, 11)" oncopy="return false" onpaste="return false"  oninput="javascript:   this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
       </v-text-field>
      </div>
      <div class="float-child">
       <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="12" :autocomplete="'off'"   maxLength="1" solo v-model="$sunidhi.emailOtp12"  @input="moveToNextField($event, 12)" oncopy="return false" onpaste="return false"  oninput="javascript:  this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
        </v-text-field>
      </div>
      <div class="float-child">
       <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="13" :autocomplete="'off'"  maxLength="1" solo v-model="$sunidhi.emailOtp13"  @input="moveToNextField($event, 13)" oncopy="return false" onpaste="return false"  oninput="javascript:  this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
        </v-text-field>
      </div>
      <div class="float-child">
       <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="14" :autocomplete="'off'"  maxLength="1" solo v-model="$sunidhi.emailOtp14"  @input="moveToNextField($event, 14)" oncopy="return false" onpaste="return false"  oninput="javascript:  this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
        </v-text-field>
      </div>
      <div class="float-child">
       <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="15" :autocomplete="'off'"  maxLength="1" solo v-model="$sunidhi.emailOtp15"  @input="moveToNextField($event, 15)" oncopy="return false" onpaste="return false"  oninput="javascript:  this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
        </v-text-field>
      </div>
      <div class="float-child">
       <v-text-field  class="mt-2 mb-0" type="password" inputmode="numeric" transition="slide-x-transition" id="16" :autocomplete="'off'"  maxLength="1" solo v-model="$sunidhi.emailOtp16" @input="moveToNextField($event, 16)" oncopy="return false" onpaste="return false"  oninput="javascript:  this.value = this.value.replace(/[^0-9]/gi, '');" :disabled='emailSuccess'>
        </v-text-field>
      </div>


      </div>
  </div>

  </v-flex>
  

 
  <div style="color:red;font-size:11px;margin: 2px 45px 0px; text-align: left;" v-if="otpMailerrormsg.length > 0">{{otpMailerrormsg}}</div><br/>
      <span style="padding-left:4rem; padding-right: 2rem; text-align: center;" >Didn't Receive OTP?
        <button type="button" style="font-size:11px;" :class="{ activeLink: !isOtpMail }" :disabled='isOtpMail' id="emailResendBtn"  @click="otpResendMail()" v-if="!emailSuccess" > Resend OTP {{otpTimerMail}} {{ otpMailMins }} </button>
      </span>
      </div>
      </slot>

     </section>

    <v-flex class="modal-footer" style="align-items: center;border-top: none !important;">
      <v-layout row justify-center >
          <v-flex xs12 sm12 md12 style="align-items: center; width: max-content;" >
              <v-btn :disabled ='$sunidhi.isDisableInitOTPProceedBtn' style="border-radius: 20px !important;" id="ProceedBtn" color="primary-btn" dark block class="text-none text-none v-btn v-btn--block theme--dark primary-btn" v-on:click="otpValidation()" >Proceed</v-btn>
          </v-flex>
      </v-layout>
  </v-flex>
  </div>
</v-card>



        <!--Preloader starts-->
        <div class="pre-loader" v-show="PreLoader==true" v-hide="PreLoader == false">
    
    <img :src="preLoaderImg">
  
  </div>
  
  <!--Preloader ends-->

  </v-container>
</template>


<!-- CSS -->


<script type="text/javascript">
import  'vue-multiselect';
// import Vue from 'vue'
import router from '@/router';
import { db } from '@/sunidhiapp';
import axios from 'axios';
import loader from '@/assets/images/Preloader.gif';
// import $ from 'jquery';
 
 
// Vue.component('vue-multiselect', window.VueMultiselect.default)
 
 
 
export default {
    name: 'initial_info',
    // components: {
    //     Multiselect,
    // },
        data: function () {
            return {
                firstName: "",
                lastName: "",
                custID: "",
                mobNo: "",
                firstNameErrorMsg: "",
                lastNameErrorMsg: "",
                custIDErrorMsg: "",
                mobNoErrorMsg: "",
                emailerrormsg: "",
                howdidyouknow: "",
                Isnextclicked: 'False',
                ISD: '+267',
                DrpDwnopt:[],
                email: "",
                mobOtp: "",
                otpMoberrormsg: "",
                isOtpMail: true,
                otpTimerMail:0,
                otpMailMins: 'secs',
                // emailOtp1: '',
                // emailOtp2: '',
                // emailOtp3: '',
                // emailOtp4: '',
                // emailOtp5: '',
                // emailOtp6: '',
                PreLoader: true,
                isModalVisible: false,
                otpMessageE:"",
                otpMessageM:"",
                mobSuccess:false,
                NationalID: "",
                msgKey:[],
                isUserExists: false,
                UserExistsErrorMessage:'',
                isNationalIDExists: false,
                digits:'',
                hdngpslocation:"",
                emailSuccess:false,
                otpMailerrormsg: "",
                preLoaderImg: loader
               
                // isdisableProceedBtn: true
               
               
            };
        },
 
//         watch: {
 
// otpTimerMail: {
   
//     handler(value) {
       
//         if(this.isModalVisible){
//         if (value > 0) {
//             // this.otpMailMins='min'
//             setTimeout(() => {
 
//                 this.otpTimerMail--;
//                 // this.otpTimerMailSecs = 60;
//             }, 1000);
//         } else {
//         // $("#emailResendBtn").addClass("activeLink");
 
//         this.otpTimerMail = "";
//         this.otpMailMins = ''
//         this.isOtpMail = false;
//         }
//         }
 
//     },
//     immediate: true // This ensures the watcher is triggered upon creation
// },
 
// },
 
   
watch: {
 
otpTimerMail: {
    handler(value) {
        if (value > 0) {
            setTimeout(() => {
 
                this.otpTimerMail--;
            }, 1000);
        }
        else {
        // $("#emailResendBtn").addClass("activeLink");
        this.otpTimerMail = "";
        this.otpMailMins = ''
        this.isOtpMail = false;
        }
        // }
 
    },
    immediate: true // This ensures the watcher is triggered upon creation
},
},
 
        mounted: async function () {
            // this.devicecheck();
            // this.getLocation();
            await this.$sunidhi.getISDcode();
            await this.populateISDcode();
            this.PreLoader = false;
            this.isOtpMail = true;
            this.$sunidhi.logoutBtnDisp = true;
            this.$sunidhi.emailOtp11 = ''
            this.$sunidhi.emailOtp12 = ''
            this.$sunidhi.emailOtp13 = ''
            this.$sunidhi.emailOtp14 = ''
            this.$sunidhi.emailOtp15 = ''
            this.$sunidhi.emailOtp16 = ''
            this.$sunidhi.isDisableInitOTPProceedBtn = true;
        },
        methods: {
           
 
    //         moveToNextField(event, id) {
    //   if (event.target.value.length === 1) {
    //     const nextInput = document.getElementById(id + 1);
    //     if (nextInput) {
    //       nextInput.focus();
    //     }
    //   }
    // },
    // moveToPreviousField(event, id) {
    //   if (event.key === 'Backspace' && event.target.value.length === 0) {
    //     const prevInput = document.getElementById(id - 1);
    //     if (prevInput) {
    //       prevInput.focus();
    //     }
    //   }
    // },
 
    moveToNextField(e, id) {
                switch (id) {
                    case 11:
                        this.$sunidhi.emailOtp11 = e;
                        break;
                    case 12:
                    this.$sunidhi.emailOtp12 = e;
                        break;
                    case 13:
                    this.$sunidhi.emailOtp13 = e;
                        break;
                    case 14:
                    this.$sunidhi.emailOtp14 = e;
                        break;
                    case 15:
                    this.$sunidhi.emailOtp15 = e;
                        break;
                    case 16:
                    this.$sunidhi.emailOtp16 = e;
                        break;
               
                    default:
                        break;
                }
                var otpVal =  this.$sunidhi.emailOtp11 +  this.$sunidhi.emailOtp12 +  this.$sunidhi.emailOtp13 +  this.$sunidhi.emailOtp14 +  this.$sunidhi.emailOtp15 +  this.$sunidhi.emailOtp16;
                if(otpVal.length < 6){
                    this.$sunidhi.isDisableInitOTPProceedBtn = true;
                    // $('ProceedBtn').addClass('disabled')
                } else if(otpVal.length == 6){
                    this.$sunidhi.isDisableInitOTPProceedBtn = false;
                    // $('ProceedBtn').removeClass('disabled')
                   
                }
                // if(id < 16 ){
                //     isDisableInitOTPProceedBtn = true;
                // } else if(id == 16){
                //     isDisableInitOTPProceedBtn = false;
                // }
                if(e.length == 1){
                const nextIndex = id + 1
                if (nextIndex <=  16) {
                    document.getElementById(nextIndex).focus();
                    }
                } else if(e.length < 1){
                    const prevIndex = id - 1
                if (prevIndex < 16 && prevIndex >=11 ) {
                    document.getElementById(prevIndex).focus();
                    }
                }        
            },
 
            // RemoveSpace(event){
            //     let val = event.target._value;
            //     let fieldName = event.target.ariaLabel;
            //     if (fieldName == 'First Name'){
            //         this.firstName = val.trim();
            //     }
            //     else if(fieldName == 'Last Name'){
            //         this.lastName = val.trim();
            //     }
               
 
            // },
            RemoveSpace(event,fieldName,fieldVal){
                
                if (fieldName == 'firstName'){
                    this.firstName = fieldVal.trim();
                }
                else if(fieldName == 'lastName'){
                    this.lastName = fieldVal.trim();
                }
               
 
            },
            emailRestrict: function(event){
                    var regex = new RegExp("^[a-zA-Z0-9.@_]+$");
                    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                    if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                    }                
                },
            populateISDcode(){
           
            if(this.$sunidhi.ISDcode.length>0){
            for(var i=0; i<this.$sunidhi.ISDcode.length; i++){
            this.DrpDwnopt.push({ "OptionValue": this.$sunidhi.ISDcode[i].LookUpCode, "OptionText": this.$sunidhi.ISDcode[i].LookUpCode });
           }
           }
           this.ISD = this.DrpDwnopt.find(option => option.OptionValue === this.ISD);
           
           setTimeout(() => {
                        this.PreLoader = false;
            }, 500);
        },
            isNumber: function(evt) {
              evt = (evt) ? evt : window.event;
              var charCode = (evt.which) ? evt.which : evt.keyCode;
              if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 43)
              {evt.preventDefault();
              } else {
                return true;
              }
            },
 
           
             isLetter(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if(/^[A-Za-z\s]*$/.test(char)){
                    if(/^\s/.test(char) && e.target._value == "") {
                    e.preventDefault();
                    }
                return true;
                } // Match with regex
               
                else
                {
                    e.preventDefault();
                } // If not match, don't add to input text
 
            },
 
            // devicecheck() {
            //     var deviceAgent = navigator.userAgent.toLowerCase();
            //     var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
            //     if (agentID) {
            //         var safari = deviceAgent.match(/(version)/);
            //         var ios = deviceAgent.match(/([1-9][2-9]_[0-9]_?)/);
            //         if (!safari || !ios) {
            //             // router.push({ name: "unsupported" });
            //         }
            //     }
               
            // },
            // getLocation() {
            //     // debugger
            //     if (navigator.geolocation) {
            //         navigator.geolocation.getCurrentPosition(position=>{
            //      this.hdngpslocation = position.coords;
            //      });
            //     }
 
            // }, showPosition(position) {
            //     jQuery.browser.location = "Latitude: " + position.coords.latitude +
            //         " & Longitude: " + position.coords.longitude;
            // },
            openModal () {
             this.isModalVisible = true;
             this.otpTimerMobile = 180; // change later
             this.otpTimerMail = 180;
            //  $("#emailResendBtn").removeClass("activeLink");
             this.otpMailMins = 'secs'
             setTimeout(() => {
                                this.PreLoader = false;
                    }, 500);
            },close() {
                this.isModalVisible = false;
                this.otpTimerMail = 0;
                this.otpMailerrormsg = "";
                this.otpEmail=false;this.mobOtp="";
            //  $("#emailResendBtn").removeClass("activeLink");
            //  $("#phoneResendBtn").removeClass("activeLink");
            this.mobSuccess = false;
            this.emailSuccess = false;
            this.Isnextclicked ='False';
             setTimeout(() => {
                                self.PreLoader = false;
                    }, 500);
            },async otpValidation () {
                var isFlag=true;
                this.otpMailerrormsg = "";
                // this.mobOtp = this.emailOtp1 + this.emailOtp2 + this.emailOtp3 + this.emailOtp4 + this.emailOtp5 + this.emailOtp6;
                this.mobOtp = this.$sunidhi.emailOtp11 + this.$sunidhi.emailOtp12 + this.$sunidhi.emailOtp13 + this.$sunidhi.emailOtp14 + this.$sunidhi.emailOtp15 + this.$sunidhi.emailOtp16;
 
                // this.otpMobileerrormsg = "";
                this.otpEmail=false;
                // this.otpSms=false;
                if (this.mobOtp.length <= 5) {
                    this.otpMailerrormsg = "Please enter valid 6 digit OTP";
                    isFlag =false;
                       
                        this.$sunidhi.emailOtp11  = '';
                        this.$sunidhi.emailOtp12  = '';
                        this.$sunidhi.emailOtp13  = '';
                        this.$sunidhi.emailOtp14  = '';
                        this.$sunidhi.emailOtp15  = '';  
                        this.$sunidhi.emailOtp16  = '';
                        // $("#emailResendBtn").removeClass("activeLink");
                        this.$sunidhi.isDisableInitOTPProceedBtn = true;
                }
 
                if(!isFlag){
                        this.$sunidhi.emailOtp11  = '';
                        this.$sunidhi.emailOtp12  = '';
                        this.$sunidhi.emailOtp13  = '';
                        this.$sunidhi.emailOtp14  = '';
                        this.$sunidhi.emailOtp15  = '';  
                        this.$sunidhi.emailOtp16  = '';
                        // $("#emailResendBtn").removeClass("activeLink");
                        this.$sunidhi.isDisableInitOTPProceedBtn = true;
                    setTimeout(() =>{
                        this.PreLoader = false;
                    },500);
                    return;
                }
                if(isFlag) {
                    isFlag =  await this.$sunidhi.verifyOtp(this.mobileNo,this.email,this.mobOtp,this);
                }
            },
           
            otpResendMail () {
                this.$sunidhi.isDisableInitOTPProceedBtn = true;
                this.otpMailerrormsg = "";
                this.$sunidhi.emailOtp11 = "";
                this.$sunidhi.emailOtp12 = "";
                this.$sunidhi.emailOtp13 = "";
                this.$sunidhi.emailOtp14 = "";
                this.$sunidhi.emailOtp15 = "";
                this.$sunidhi.emailOtp16 = "";
                this.$sunidhi.resendEmailOtp(this.mobileNo,this.email,this.userid,this)
                this.otpTimerMail = 180;
               this.otpMailMins ='secs';
               
               this.$sunidhi.isDisabled = true;
               this.$sunidhi.isActive = false
                this.isOtpMail = true;
            },
            validEmail: function (email) {
                var reg = /^([A-Za-z0-9_.]+)@([A-Za-z0-9_.-])+\.([A-Za-z]{2,4})$/;
                if (reg.test(email) == false) {
                    return false;
                }
 
                return true;
            },
            isAlphabetSpace(event){
                    var regex = new RegExp("^[a-zA-Z ]+$");
                    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                    if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                    }
                },

                
 
 
 
 
            async continue_button_click() {
                var self= this;
                self.PreLoader = true;
                self.firstNameErrorMsg= "";
                self.lastNameErrorMsg= "";
                self.custIDErrorMsg= "";
                self.mobNoErrorMsg= "";
                self.emailerrormsg= "";
 
                var vaerror = 0;
 
                if(self.firstName.length <=0){
                    self.firstNameErrorMsg= "Enter the First Name";
                    vaerror = 1;
                }
 
                if(self.lastName.length <=0){
                    self.lastNameErrorMsg= "Enter the Last Name";
                    vaerror = 1;
                }
               
                if(self.custID.length <=0){
                    self.custIDErrorMsg= "Enter the Customer ID";
                    vaerror = 1;
                }
 
               
 
                if(self.ISD== null || self.mobNo.length <=0){
                    self.mobNoErrorMsg= "Enter the Mobile Number";
                    vaerror = 1;
                }
                else if(self.mobNo.length > 0 && self.mobNo.length <8){
                    self.mobNoErrorMsg= "Mobile Number should contain minimum of 8 digits";
                    vaerror = 1;
 
                }
 
                  if (this.email.length <= 0) {
                    this.emailerrormsg = "Enter Email ID";
                    vaerror = 1;
                }
                else {
                    if(this.email.length > 0){
                    if (!this.validEmail(this.email)) {
                        this.emailerrormsg = "Enter valid Email ID";
                        vaerror = 1;
                    }
                    }
                }
 
                if(vaerror == 1){
                    setTimeout(() =>{
                        self.PreLoader = false;
                        return;
                    },500);
                }
 
 
                else {
 
                var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                if (genzdata != null && genzdata.length > 0) {
                    await db.TbGenz.update(genzdata[0].PkId, { firstname: self.firstName,lastName: self.lastName, NationID: self.custID, mobilenumber: self.mobNo,isdcode:this.ISD.OptionText});
                } else {
                    await db.TbGenz.put({ UserId: 1,  firstname: self.firstName,lastName: self.lastName, NationID: self.custID, mobilenumber: self.mobNo,isdcode:this.ISD.OptionText });
                    genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                }
               
 
                this.Isnextclicked = 'True';
               
                var objectuser = new Object();
                var isdCode = self.ISD.OptionText;
                objectuser.firstName = self.firstName;
                objectuser.lastName = self.lastName;
                objectuser.phonenumber = isdCode+"-"+self.mobNo;
                objectuser.custID = self.custID;
                objectuser.PWAUserSessionId = genzdata[0].PWAUserSessionId;
               
              

                var generateIdObj = new FormData();
                generateIdObj.append('PWADSAUserId', genzdata[0].DSAUserId);
                generateIdObj.append('PWAUserBranchCode', genzdata[0].PWAUserBranchCode);
               
      
 
                genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
              
               
                try {
                  const response = await axios.post(
                    `${this.$sunidhi.externalURL}generateid/?token=9D744B9E-DD59-4970-8C8A-A25870142210&PWAUserSessionId=${objectuser.PWAUserSessionId}`,
                    generateIdObj, 
                    {
                      responseType: "json",
                      body: generateIdObj,
                      headers: {
                        // Add any headers if needed
                      }
                    }
                  );
 
    const data = response.data;
 
    if (data) {
      if (data.PWAUserSessionStatus === "expired") {
        setTimeout(() => {
          self.PreLoader = false;
        }, 500);
        this.$sunidhi.logoutBtnDisp = false;
        router.push({ name: 'SessionTimeout' });
      } else if (data.result.PWAUserSessionStatus === "Active") {
        await db.TbGenz.update(genzdata[0].PkId, { token: data.result.id });
        self.userid = data.result.id;
        await self.callapis();
      }
    }
  } catch (error) {
    console.log("error:", error);
    self.Isnextclicked = 'False';
    await self.callapis();
    setTimeout(() => {
      self.PreLoader = false;
    }, 500);
  }
            }
             
 
            },
 
 
            async callapis() {
                var userid = "";
                var objectuser = new Object();
                var isdCode = this.ISD.OptionText;
                var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                objectuser.firstName = this.firstName;
                objectuser.lastName = this.lastName;
                objectuser.custID = this.custID;
                objectuser.email = this.email;
                objectuser.phonenumber = isdCode+"-"+this.mobNo;
                objectuser.PWAUserSessionId = genzdata[0].PWAUserSessionId;
 
                if (this.hdngpslocation != null &&
                    this.hdngpslocation != undefined &&
                    this.hdngpslocation.length > 0) {
                    objectuser.latitude = this.hdngpslocation.split(",")[0];
                    objectuser.longitude = this.hdngpslocation.split(",")[1];
                }else if (this.hdngpslocation instanceof Object) {
                    if(this.hdngpslocation.latitude && this.hdngpslocation.longitude){
                        objectuser.latitude = this.hdngpslocation.latitude;
                        objectuser.longitude = this.hdngpslocation.longitude;
                    }
                }
 
                if (this.userid != null && this.userid.length > 0) {
                    userid = this.userid;
                } else {
                    genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                    if (genzdata != null && genzdata.length != 0) {
                        if (typeof genzdata[0].token != 'undefined') {
                            userid = genzdata[0].token;
                        }
                    }
                }
 
               
                try {
    const response = await axios.post(
      `${this.$sunidhi.externalURL}getoptions/?userid=${userid}&PWAUserSessionId=${genzdata[0].PWAUserSessionId}`,
      null, // No data to send in the body
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,POST',
          'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept",
        },
        responseType: "json"
      }
    );
 
    const data = response.data;
 
    if (data.PWAUserSessionStatus === "expired") {
      setTimeout(() => {
        self.PreLoader = false;
      }, 500);
      this.$sunidhi.logoutBtnDisp = false;
      router.push({ name: 'SessionTimeout' });
    }
 
    if (data.PWAUserSessionStatus === "Active") {
      if (data.message === "Success") {
        var eyeblink = "";
        var headlefttilt = "";
        var headrighttilt = "";
        var arr = [...data.result["eye-blinks"], ...data.result["head-left-tilt"], ...data.result["head-right-tilt"]];
        var min = Math.min(...arr);
 
        if (data.result["eye-blinks"] != null && data.result["eye-blinks"].length > 0) {
          var blink = [];
          data.result["eye-blinks"].forEach(item => {
            blink.push(parseInt(item) - parseInt(min));
          });
          eyeblink = blink.join(",");
        }
 
        if (data.result["head-left-tilt"] != null && data.result["head-left-tilt"].length > 0) {
          var lefttilt = [];
          data.result["head-left-tilt"].forEach(item => {
            lefttilt.push(parseInt(item) - parseInt(min));
          });
          headlefttilt = lefttilt.join(",");
        }
 
        if (data.result["head-right-tilt"] != null && data.result["head-right-tilt"].length > 0) {
          var rigttilt = [];
          data.result["head-right-tilt"].forEach(item => {
            rigttilt.push(parseInt(item) - parseInt(min));
          });
          headrighttilt = rigttilt.join(",");
        }
 
        const genzdataUpdate = await db.TbGenz.where("token").equals(userid).toArray();
 
        if (genzdataUpdate != null && genzdataUpdate.length > 0) {
          await db.TbGenz.update(genzdataUpdate[0].PkId, {
            eyeblink: eyeblink,
            headlefttilt: headlefttilt,
            headrighttilt: headrighttilt
          });
        }
      }
    }
  } catch (error) {
    console.log("error:", error);
  }
 
                var fvformData = new FormData();
 
                genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                if (genzdata != null && genzdata.length > 0) {
                    await db.TbGenz.update(genzdata[0].PkId, {PWADSAUserId :genzdata[0].DSAUserId});
                } else {
                    await db.TbGenz.put({ UserId: 1,  PWADSAUserId :genzdata[0].DSAUserId });
                    genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                }
 
                fvformData.append('CustUserid', userid);
                fvformData.append('PWADSAUserId',genzdata[0].DSAUserId );
                fvformData.append('PWAUserType', this.$sunidhi.PwaUserType);
                fvformData.append('PWAUserSessionId', genzdata[0].PWAUserSessionId);
                fvformData.append('userdata', JSON.stringify(objectuser));
 
               
               
               
                var self = this;
                try {
    const response = await axios.post(this.$sunidhi.externalURL + 'newuserdetails/', fvformData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        "ngrok-skip-browser-warning": '69420'
      }
    });
 
    const data1 = response.data;
 
    if (data1.result.PWAUserSessionStatus === "expired") {
      setTimeout(() => {
        self.PreLoader = false;
      }, 500);
      this.$sunidhi.logoutBtnDisp = false;
      router.push({ name: 'SessionTimeout' });
    }
 
    if (data1.result.PWAUserSessionStatus === "Active") {
      if (data1.message === "Success") {
        if (userid != null && userid !== "" && userid.length > 0) {
          self.userid = userid;
          // router.push({ name: "liveness_landingPage", params: { userid: userid } });
          self.email = objectuser.email;
          self.mobileNo = objectuser.phonenumber;
 
          if (genzdata != null && genzdata.length > 0) {
            await db.TbGenz.update(genzdata[0].PkId, { email: self.email });
          } else {
            await db.TbGenz.put({ UserId: 1, email: self.email });
            genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
          }
 
          setTimeout(() => {
            this.PreLoader = false;
          }, 500);
 
          await this.$sunidhi.resendEmailOtp(self.mobileNo, self.email, self.userid, self);
        }
      } else {
        self.Isnextclicked = 'False';
        alert("Error in creating user");
      }
    }
  } catch (error) {
    console.log("error:", error);
    self.Isnextclicked = 'False';
    alert("Error in posting user details");
  }
            }
        }
           
           
    };
</script>

<style lang="css" scoped>
.initialInfoContainer{
  background-color: white;
  /* transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  position: absolute; */
}

.resendOtp{
	border: none;
    box-shadow: none!important;
    margin-top: -10px!important;
    /* float: right; */
	color: #938e8e!important;
	background-color: transparent!important;

}
.activeLink{
color: #e3352a!important;

}
.activeLink:hover{
 text-decoration-line: underline;
 }
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3) !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
	width:50%;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

  .float-child {
    width: 13%;
    float: left;
    padding: 0px;
    margin-right: 8px;
  }

  .preLoginHeaderstyle {
    text-align: center !important;
    font-size: 20px !important; 
    /* padding-top: 70px !important; */
  }

  
  @media only screen and (max-width: 959px) {
            #createAccount{
                padding-top: 0px !important;
                text-align: center !important;

            }}

            /* .two-col {
    overflow: hidden;
    width: 100%;
} */

/* .two-col .col1,
.two-col .col2 {
    width: 49%;
} */

 .col1 {
    float: left;
    width: 90%;
}

 .col2 {
    float: right; 
    width: 10%;
}

.ISDStyle{
    float:left;
    width:15%;
    margin-right:1%
}

/* .two-col label {
    display: block;
} */

/* @media only screen and (max-width: 800px){
    .ISDStyle{
    width:18% !important;
    }
} */
/* @media only screen and (max-width:456px ){
    .ISDStyle{
    width:44% !important;
    }
} */
/* @media only screen and (max-width: 576px){
    .ISDStyle{
    width:30% !important;
    }
} */
@media only screen and (max-width: 959px) {
            #mobNumStyle{
                width: 60%;

            }}
@media only screen and (max-width: 959px) {
          #isdCodeStyle{
                width: 40%;

            }}
</style>